import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChildBirthCertificate } from 'src/app/interfaces/child-birth-certificate';

@Injectable({
  providedIn: 'root'
})
export class ChildBirthCertificateService {
  private readonly childBirthCertificateSubject = new BehaviorSubject<ChildBirthCertificate | null>(null);

  public readonly childBirthCertificate$: Observable<ChildBirthCertificate | null> =
    this.childBirthCertificateSubject.asObservable();

  setChildBirthCertificate(value: ChildBirthCertificate | null): void {
    this.childBirthCertificateSubject.next(value);
  }
}
